import { Outlet } from "react-router-dom";

export default function Setting() {
  return <Outlet />;
}
